module.exports = __webpack_public_path__ + "img/36.6a5e574d.png";